import { render, staticRenderFns } from "./VsAlert.vue?vue&type=template&id=54121e08&lang=pug&"
import script from "./VsAlert.vue?vue&type=script&lang=js&"
export * from "./VsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54121e08')) {
      api.createRecord('54121e08', component.options)
    } else {
      api.reload('54121e08', component.options)
    }
    module.hot.accept("./VsAlert.vue?vue&type=template&id=54121e08&lang=pug&", function () {
      api.rerender('54121e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsAlert.vue"
export default component.exports